module.exports = __webpack_public_path__ + "www.f35f8018e795d64f43e9.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/www.png
// module id = ../../../../../src/assets/images/www.png
// module chunks = main